const getDetails = {
  n: true,
  id: true,
  r: true,
  brid: true,
  br: true,
  art: true,
};

export {getDetails}